// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"08333fa7cbe2c957","9266":"b05cec27e9a3093b"}[chunkId] + ".css";
};